module.exports = __webpack_public_path__ + "img/knee_lift.875d87b8.png";